'use es6';

export const applyLegendPosition = (visualization, report) => {
  const legendPosition = report.getIn(['displayParams', 'legendPosition']);
  const legendWidth = report.getIn(['displayParams', 'legendWidth']);
  if (legendPosition) {
    visualization = visualization.setIn(['style', 'legendPosition'], legendPosition);
  }
  if (legendWidth) {
    visualization = visualization.setIn(['style', 'legendWidth'], legendWidth);
  }
  return visualization;
};